import { PlusIcon } from '@heroicons/react/24/outline';
import { tenant } from '@tenant';

import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import {
  AUTHENTICATION_HEADER_CREATE_TEST_ID,
  AUTHENTICATION_HEADER_TEST_ID,
  AUTHENTICATION_SUBTITLE_TEST_ID,
  AUTHENTICATION_TITLE_TEST_ID
} from './constants';

type AuthenticationHeaderProps = {
  showCreateAction: boolean;
  onCreate: () => void;
};

export const AuthenticationHeader = ({
  showCreateAction,
  onCreate
}: AuthenticationHeaderProps) => (
  <header
    data-testid={AUTHENTICATION_HEADER_TEST_ID}
    className="flex w-full items-center gap-4"
  >
    <div className="flex flex-1 flex-col gap-2">
      <h1
        data-testid={AUTHENTICATION_TITLE_TEST_ID}
        className="text-2xl font-medium leading-[29px] text-content-primary"
      >
        Authentication keys
      </h1>
      <p
        data-testid={AUTHENTICATION_SUBTITLE_TEST_ID}
        className="text-sm font-normal leading-[18px] text-content-primary"
      >
        API keys are used to authenticate your account when interacting with the{' '}
        {tenant.name.company} API
      </p>
    </div>
    {showCreateAction && (
      <Restricted requiredPermission="developers:manage">
        <PrimaryButton
          data-testid={AUTHENTICATION_HEADER_CREATE_TEST_ID}
          icon={<PlusIcon className="size-4" />}
          onClick={onCreate}
        >
          Create new key
        </PrimaryButton>
      </Restricted>
    )}
  </header>
);
